import { useMediaQuery } from "react-responsive";
import { RegistrationLayoutDesktop } from "./RegistrationLayoutDesktop.js"
import { RegistrationLayoutMobile } from "./RegistrationLayoutMobile.js"

function RegistrationLayout() {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return isMobile ? <RegistrationLayoutMobile /> : <RegistrationLayoutDesktop />;
}

export default RegistrationLayout;